import Image from "next/image";
import { getDebateThumbnail } from "../Discuss/util";
import { TYPO } from "styles/Typo";
import { useRouter } from "next/router";
import { useEffect, useRef, useState } from "react";
import BriefingAllViewed from "./AllViewed";
import { Forward } from "components/common/Icons";
import { TrackedList, TrackedListItem } from "lib/analytics/react/list";

function BriefingSlide({
  data,
  date,
  currentPage,
  isMobile,
  isFinishPage,
}: {
  data: any;
  date: string;
  currentPage: number;
  isMobile: boolean;
  isFinishPage: boolean;
}) {
  const router = useRouter();
  // SSR/첫 HTML에도 카드 본문이 나가도록 기본 너비로 시작 (useEffect 측정으로 보정)
  const [currentWidth, setCurrentWidth] = useState<number>(
    isMobile ? 360 : 800
  );
  const [scrollLeft, setScrollLeft] = useState<number>(0);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current) {
      setCurrentWidth(containerRef.current.clientWidth);
    }

    const handleWindowResize = () => {
      if (containerRef.current) {
        setCurrentWidth(containerRef.current.clientWidth);
      }
    };
    window.addEventListener("resize", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
  }, [currentPage]);

  useEffect(() => {
    if (containerRef.current) {
      setCurrentWidth(containerRef.current.clientWidth);
    }
  }, [containerRef.current]);

  useEffect(() => {
    if (containerRef.current && currentWidth) {
      setScrollLeft(currentWidth * currentPage);
    }
  }, [currentPage, currentWidth]);

  return (
    <div className="w-full  pb-[90px] overflow-hidden relative pt-4">
      <div
        className="absolute top-0 left-0 w-screen max-w-[800px] h-full"
        ref={containerRef}
      ></div>
      <TrackedList listId="briefing_cards" totalCount={data?.length}>
        {
          <div
            className="overflow-x-auto flex scroll w-fit"
            style={{
              transform: `translateX(-${scrollLeft}px)`,
              // transition: enableTransition ? "transform 0.5s ease-in-out" : "none",
              transition: "transform 0.3s ease-in-out",
            }}
          >
            {data?.map((item: any, index: number) => {
              const thumbnail = getDebateThumbnail(
                item?.thumbnail_url,
                item?.id
              );
              return (
                <div
                  key={index}
                  className="px-4 shrink-0 flex justify-center w-full z-[1] h-fit"
                  style={{
                    width: currentWidth
                      ? currentWidth
                      : typeof window !== "undefined"
                      ? isMobile
                        ? window.innerWidth
                        : "800px"
                      : 0,
                    maxWidth: "100%",
                  }}
                >
                  <TrackedListItem
                    itemData={{
                      kind: "report",
                      report_id: item?.id,
                      rank: index + 1,
                    }}
                    href={`/discuss/${
                      item?.url_slug
                        ? `${item?.url_slug}-${item?.id}`
                        : `${item?.id}`
                    }`}
                    // asTrace={true}
                    className="w-full  flex flex-col rounded-[12px] border border-gray15 bg-white cursor-pointer overflow-hidden"
                    style={{
                      maxWidth: isMobile ? "100%" : "500px",
                    }}
                    // onClick={() => {
                    //   router.push(
                    //     `/discuss/${
                    //       item?.url_slug
                    //         ? `${item?.url_slug}-${item?.id}`
                    //         : `${item?.id}`
                    //     }`
                    //   );
                    // }}
                  >
                    <div
                      className="relative w-full aspect-[2/1] flex items-end pb-5 px-5"
                      style={{
                        background: `linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.70) 70.1%), url('${thumbnail}') center/cover no-repeat`,
                      }}
                    >
                      <p
                        className={`${TYPO.TYPO4_SB} text-white custom-word-break`}
                      >
                        {item?.title}
                      </p>
                    </div>

                    <div className="p-5 flex flex-col gap-2">
                      <p
                        className={`text-[16px] leading-[28px] text-gray90 custom-word-break`}
                      >
                        {item?.brief_100 || ""}
                      </p>
                    </div>
                    <div className="flex justify-center items-center px-4 py-[14px] gap-1 border-t border-gray15 cursor-pointer">
                      <p className={`${TYPO.TYPO7_MD} text-gray60`}>
                        자세히 보기
                      </p>
                      <Forward fill="gray60" width={12} height={12} />
                    </div>
                  </TrackedListItem>
                </div>
              );
            })}
            <div
              className="pt-8 shrink-0 flex justify-center w-full z-[1] h-fit"
              style={{
                width: currentWidth,
              }}
            >
              <BriefingAllViewed
                date={date}
                isMobile={isMobile}
                isFinishPage={isFinishPage}
              />
            </div>
          </div>
        }
      </TrackedList>
    </div>
  );
}
export default BriefingSlide;
